export const recurringDepositeData = {
    "recurringDeposits": [
        {
            "amount": "19",
            "endDate": "2022-09-17",
            "accountType": "SA",
            "transactions": [
                {
                    "id": 4536,
                    "date": "2022-06-10",
                    "amount": 19.57,
                    "particular": "APBS C- BPCL LPG SUBSIDY-P062201AAE943 ",
                    "counterparty": "Bpcl",
                    "tags": "",
                    "balance": 17743.36,
                    "cheque_number": "0000002179151841 ",
                    "type": "CR",
                    "computedBalance": 17743.36,
                    "balanceGap": 0.0,
                    "categories": "Subsidy",
                    "upiApp": ""
                },
                {
                    "id": 4734,
                    "date": "2022-09-17",
                    "amount": 19.57,
                    "particular": "APBS C- BPCL LPG SUBSIDY-P092202F797CF ",
                    "counterparty": "Bpcl",
                    "tags": "",
                    "balance": 11233.63,
                    "cheque_number": "0000004808368985 ",
                    "type": "CR",
                    "computedBalance": 11233.63,
                    "balanceGap": 0.0,
                    "categories": "Subsidy",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "24",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "SA",
                "bankName": "HDFC Bank",
                "accountNumber": "07181610047017"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "Bpcl",
            "interval": "QUARTERLY",
            "transactionCount": "2",
            "particulars": "APBS C- BPCL LPG SUBSIDY-P062201AAE943",
            "account": "07181610047017",
            "startDate": "2022-06-10"
        },
        {
            "amount": "10000",
            "endDate": "2022-10-14",
            "accountType": "SA",
            "transactions": [
                {
                    "id": 4537,
                    "date": "2022-06-10",
                    "amount": 10000.0,
                    "particular": "UPI-SHARMILA DAS BASU-9830495229@YBL-BDB L0001721-216172825260-PAYMENT FROM PHONE ",
                    "counterparty": "Sharmila Das Basu",
                    "tags": "Third Party Transfer, UPI",
                    "balance": 27743.36,
                    "cheque_number": "0000216172825260 ",
                    "type": "CR",
                    "computedBalance": 27743.36,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / UPI",
                    "upiApp": ""
                },
                {
                    "id": 4762,
                    "date": "2022-10-14",
                    "amount": 10000.0,
                    "particular": "UPI-SHARMILA DAS BASU-9830495229@YBL-BDB L0001721-228789841542-PAYMENT FROM PHONE ",
                    "counterparty": "Sharmila Das Basu",
                    "tags": "Third Party Transfer, UPI",
                    "balance": 32026.21,
                    "cheque_number": "0000228789841542 ",
                    "type": "CR",
                    "computedBalance": 32026.21,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / UPI",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "24",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "SA",
                "bankName": "HDFC Bank",
                "accountNumber": "07181610047017"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Sharmila Das Basu",
            "interval": "IRREGULAR",
            "transactionCount": "2",
            "particulars": "UPI-SHARMILA DAS BASU-9830495229@YBL-BDB L0001721-216172825260-PAYMENT FROM PHONE",
            "account": "07181610047017",
            "startDate": "2022-06-10"
        },
        {
            "amount": "180",
            "endDate": "2022-08-10",
            "accountType": "SA",
            "transactions": [
                {
                    "id": 4438,
                    "date": "2022-05-11",
                    "amount": 180.0,
                    "particular": "NEFT CR-DEUT0784BBY-TATA CONSULTANCY-RAN JAN KUMAR BASU-213101169GN00747 ",
                    "counterparty": "Tata Consultancy, Ran Kumar Basu",
                    "tags": "NEFT",
                    "balance": 114659.05,
                    "cheque_number": "213101169GN00747 ",
                    "type": "CR",
                    "computedBalance": 114659.05,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4532,
                    "date": "2022-06-09",
                    "amount": 180.0,
                    "particular": "NEFT CR-DEUT0784BBY-TATA CONSULTANCY-RAN JAN KUMAR BASU-216001533GN13915 ",
                    "counterparty": "Tata Consultancy, Ran Kumar Basu",
                    "tags": "NEFT",
                    "balance": 18848.79,
                    "cheque_number": "216001533GN13915 ",
                    "type": "CR",
                    "computedBalance": 18848.79,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4604,
                    "date": "2022-07-06",
                    "amount": 180.0,
                    "particular": "NEFT CR-DEUT0784BBY-TATA CONSULTANCY-RAN JAN KUMAR BASU-218702431GN08911 ",
                    "counterparty": "Tata Consultancy, Ran Kumar Basu",
                    "tags": "NEFT",
                    "balance": 40984.06,
                    "cheque_number": "218702431GN08911 ",
                    "type": "CR",
                    "computedBalance": 40984.06,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4694,
                    "date": "2022-08-10",
                    "amount": 180.0,
                    "particular": "NEFT CR-DEUT0784BBY-TATA CONSULTANCY-RAN JAN KUMAR BASU-222202722GN00376 ",
                    "counterparty": "Tata Consultancy, Ran Kumar Basu",
                    "tags": "NEFT",
                    "balance": 9573.36,
                    "cheque_number": "222202722GN00376 ",
                    "type": "CR",
                    "computedBalance": 9573.36,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "24",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "SA",
                "bankName": "HDFC Bank",
                "accountNumber": "07181610047017"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "Tata Consultancy, Ran Kumar Basu",
            "interval": "MONTHLY",
            "transactionCount": "4",
            "particulars": "NEFT CR-DEUT0784BBY-TATA CONSULTANCY-RAN JAN KUMAR BASU-213101169GN00747",
            "account": "07181610047017",
            "startDate": "2022-05-11"
        },
        {
            "amount": "183960",
            "endDate": "2022-04-26",
            "accountType": "CA",
            "transactions": [
                {
                    "id": 4181,
                    "date": "2022-04-13",
                    "amount": 183960.0,
                    "particular": "NEFT/CIUBH22103022256/KOUMUS AUTO\nCOMPONENTS//ATT ",
                    "counterparty": "Koumus Auto Components",
                    "tags": "NEFT",
                    "balance": 235235.56,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 235235.56,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4191,
                    "date": "2022-04-26",
                    "amount": 183960.0,
                    "particular": "NEFT/CIUBH22116048993/KOUMUS AUTO\nCOMPONENTS//ATT ",
                    "counterparty": "Koumus Auto Components",
                    "tags": "NEFT",
                    "balance": 213565.76,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 213565.76,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "22",
            "accountDetails": {
                "bankAbbreviation": "AXISIN",
                "accountType": "CA",
                "bankName": "Axis Bank",
                "accountNumber": "921020008069979"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "Koumus Auto Components",
            "interval": "FORTNIGHTLY",
            "transactionCount": "2",
            "particulars": "NEFT/CIUBH22103022256/KOUMUS AUTO COMPONENTS//ATT",
            "account": "921020008069979",
            "startDate": "2022-04-13"
        },
        {
            "amount": "25000",
            "endDate": "2022-10-22",
            "accountType": "CA",
            "transactions": [
                {
                    "id": 4316,
                    "date": "2022-07-14",
                    "amount": 25000.0,
                    "particular": "NEFT/CIUBH22195031472/MECH POLYMERS//ATTN/ ",
                    "counterparty": "Mech Polymers",
                    "tags": "NEFT",
                    "balance": 628958.28,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 628958.28,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4426,
                    "date": "2022-08-27",
                    "amount": 25000.0,
                    "particular": "NEFT/CIUBH22239015050/MECH POLYMERS//ATTN/ ",
                    "counterparty": "Mech Polymers",
                    "tags": "NEFT",
                    "balance": 931025.06,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 931025.06,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4439,
                    "date": "2022-09-05",
                    "amount": 25000.0,
                    "particular": "NEFT/CIUBH22248034873/MECH POLYMERS//ATTN/ ",
                    "counterparty": "Mech Polymers",
                    "tags": "NEFT",
                    "balance": 67330.06,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 67330.06,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4550,
                    "date": "2022-09-23",
                    "amount": 25000.0,
                    "particular": "NEFT/CIUBH22266048112/MECH POLYMERS//ATTN/ ",
                    "counterparty": "Mech Polymers",
                    "tags": "NEFT",
                    "balance": 206259.22,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 206259.22,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4651,
                    "date": "2022-10-22",
                    "amount": 25000.0,
                    "particular": "NEFT/CIUBH22295004604/MECH POLYMERS//ATTN/ ",
                    "counterparty": "Mech Polymers",
                    "tags": "NEFT",
                    "balance": 137098.83,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 137098.83,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "22",
            "accountDetails": {
                "bankAbbreviation": "AXISIN",
                "accountType": "CA",
                "bankName": "Axis Bank",
                "accountNumber": "921020008069979"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Mech Polymers",
            "interval": "IRREGULAR",
            "transactionCount": "5",
            "particulars": "NEFT/CIUBH22195031472/MECH POLYMERS//ATTN/",
            "account": "921020008069979",
            "startDate": "2022-07-14"
        },
        {
            "amount": "50000",
            "endDate": "2022-08-20",
            "accountType": "CA",
            "transactions": [
                {
                    "id": 4325,
                    "date": "2022-07-21",
                    "amount": 50000.0,
                    "particular": "NEFT/CIUBH22202077323/MECH POLYMERS//ATTN/ ",
                    "counterparty": "Mech Polymers",
                    "tags": "NEFT",
                    "balance": 109978.28,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 109978.28,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4403,
                    "date": "2022-08-20",
                    "amount": 50000.0,
                    "particular": "NEFT/CIUBH22232087284/MECH POLYMERS//ATTN/ ",
                    "counterparty": "Mech Polymers",
                    "tags": "NEFT",
                    "balance": 1593862.06,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 1593862.06,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "22",
            "accountDetails": {
                "bankAbbreviation": "AXISIN",
                "accountType": "CA",
                "bankName": "Axis Bank",
                "accountNumber": "921020008069979"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "Mech Polymers",
            "interval": "MONTHLY",
            "transactionCount": "2",
            "particulars": "NEFT/CIUBH22202077323/MECH POLYMERS//ATTN/",
            "account": "921020008069979",
            "startDate": "2022-07-21"
        },
        {
            "amount": "7000",
            "endDate": "2022-06-11",
            "accountType": "CA",
            "transactions": [
                {
                    "id": 4204,
                    "date": "2022-05-09",
                    "amount": 7000.0,
                    "particular": "MOB/TPFT/SANJEEV KUMAR/916010076559458 ",
                    "counterparty": "Sanjeev Kumar",
                    "tags": "Third Party Transfer",
                    "balance": 74122.71,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 74122.71,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / Third Party Transfer",
                    "upiApp": ""
                },
                {
                    "id": 4257,
                    "date": "2022-06-11",
                    "amount": 7000.0,
                    "particular": "MOB/TPFT/SANJEEV KUMAR/916010076559458 ",
                    "counterparty": "Sanjeev Kumar",
                    "tags": "Third Party Transfer",
                    "balance": 227867.34,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 227867.34,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / Third Party Transfer",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "22",
            "accountDetails": {
                "bankAbbreviation": "AXISIN",
                "accountType": "CA",
                "bankName": "Axis Bank",
                "accountNumber": "921020008069979"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "Sanjeev Kumar",
            "interval": "MONTHLY",
            "transactionCount": "2",
            "particulars": "MOB/TPFT/SANJEEV KUMAR/916010076559458",
            "account": "921020008069979",
            "startDate": "2022-05-09"
        },
        {
            "amount": "30000",
            "endDate": "2022-06-06",
            "accountType": "CA",
            "transactions": [
                {
                    "id": 4163,
                    "date": "2022-04-04",
                    "amount": 30000.0,
                    "particular": "MOB/TPFT/SANJEEV KUMAR/916010076559458 ",
                    "counterparty": "Sanjeev Kumar",
                    "tags": "Third Party Transfer",
                    "balance": 79871.09,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 79871.09,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / Third Party Transfer",
                    "upiApp": ""
                },
                {
                    "id": 4239,
                    "date": "2022-06-06",
                    "amount": 30000.0,
                    "particular": "MOB/TPFT/SANJEEV KUMAR/916010076559458 ",
                    "counterparty": "Sanjeev Kumar",
                    "tags": "Third Party Transfer",
                    "balance": 66689.09,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 66689.09,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / Third Party Transfer",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "22",
            "accountDetails": {
                "bankAbbreviation": "AXISIN",
                "accountType": "CA",
                "bankName": "Axis Bank",
                "accountNumber": "921020008069979"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Sanjeev Kumar",
            "interval": "IRREGULAR",
            "transactionCount": "2",
            "particulars": "MOB/TPFT/SANJEEV KUMAR/916010076559458",
            "account": "921020008069979",
            "startDate": "2022-04-04"
        },
        {
            "amount": "100000",
            "endDate": "2022-09-13",
            "accountType": "CA",
            "transactions": [
                {
                    "id": 4468,
                    "date": "2022-09-10",
                    "amount": 100000.0,
                    "particular": "NEFT/IDIBH22253193196/SWIFT SUPPORT SERVICES//URG ",
                    "counterparty": "Support Services",
                    "tags": "NEFT",
                    "balance": 818362.06,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 818362.06,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4500,
                    "date": "2022-09-13",
                    "amount": 100000.0,
                    "particular": "NEFT/IDIBH22256430606/SWIFT SUPPORT SERVICES//URG ",
                    "counterparty": "Support Services",
                    "tags": "NEFT",
                    "balance": 339716.06,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 339716.06,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "22",
            "accountDetails": {
                "bankAbbreviation": "AXISIN",
                "accountType": "CA",
                "bankName": "Axis Bank",
                "accountNumber": "921020008069979"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Support Services",
            "interval": "IRREGULAR",
            "transactionCount": "2",
            "particulars": "NEFT/IDIBH22253193196/SWIFT SUPPORT SERVICES//URG",
            "account": "921020008069979",
            "startDate": "2022-09-10"
        },
        {
            "amount": "100000",
            "endDate": "2022-07-19",
            "accountType": "CA",
            "transactions": [
                {
                    "id": 4220,
                    "date": "2022-05-17",
                    "amount": 100000.0,
                    "particular": "NEFT/27618023492DC/VISNUKUMAR TRADERS P/GGS Enter ",
                    "counterparty": "Visnukumar Traders P",
                    "tags": "NEFT",
                    "balance": 121060.46,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 121060.46,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4323,
                    "date": "2022-07-19",
                    "amount": 100000.0,
                    "particular": "NEFT/28602090751DC/VISNUKUMAR TRADERS P/GGS\nENTER ",
                    "counterparty": "Visnukumar Traders P",
                    "tags": "NEFT",
                    "balance": 159978.28,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 159978.28,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "22",
            "accountDetails": {
                "bankAbbreviation": "AXISIN",
                "accountType": "CA",
                "bankName": "Axis Bank",
                "accountNumber": "921020008069979"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Visnukumar Traders P",
            "interval": "IRREGULAR",
            "transactionCount": "2",
            "particulars": "NEFT/27618023492DC/VISNUKUMAR TRADERS P/GGS Enter",
            "account": "921020008069979",
            "startDate": "2022-05-17"
        },
        {
            "amount": "500000",
            "endDate": "2022-10-07",
            "accountType": "CA",
            "transactions": [
                {
                    "id": 4165,
                    "date": "2022-04-05",
                    "amount": 500000.0,
                    "particular": "NEFT/27009044677DC/VISNUKUMAR TRADERS P/GGS Enter ",
                    "counterparty": "Visnukumar Traders P",
                    "tags": "NEFT",
                    "balance": 599070.09,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 599070.09,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4241,
                    "date": "2022-06-07",
                    "amount": 500000.0,
                    "particular": "NEFT/27948380302DC/VISNUKUMAR TRADERS P/GG Enterp ",
                    "counterparty": "Visnukumar Traders P",
                    "tags": "NEFT",
                    "balance": 590440.09,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 590440.09,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4291,
                    "date": "2022-07-07",
                    "amount": 500000.0,
                    "particular": "NEFT/28419723523DC/VISNUKUMAR TRADERS P/GGS Enter ",
                    "counterparty": "Visnukumar Traders P",
                    "tags": "NEFT",
                    "balance": 1038857.13,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 1038857.13,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4355,
                    "date": "2022-08-06",
                    "amount": 500000.0,
                    "particular": "NEFT/28886159776DC/VISNUKUMAR TRADERS P/GGS Enter ",
                    "counterparty": "Visnukumar Traders P",
                    "tags": "NEFT",
                    "balance": 614486.28,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 614486.28,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4443,
                    "date": "2022-09-06",
                    "amount": 500000.0,
                    "particular": "NEFT/29233569315DC/VISNUKUMAR TRADERS P/GGS Enter ",
                    "counterparty": "Visnukumar Traders P",
                    "tags": "NEFT",
                    "balance": 552330.06,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 552330.06,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4597,
                    "date": "2022-10-07",
                    "amount": 500000.0,
                    "particular": "NEFT/29594459841DC/VISNUKUMAR TRADERS P/GGS Enter ",
                    "counterparty": "Visnukumar Traders P",
                    "tags": "NEFT",
                    "balance": 1136088.45,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 1136088.45,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "22",
            "accountDetails": {
                "bankAbbreviation": "AXISIN",
                "accountType": "CA",
                "bankName": "Axis Bank",
                "accountNumber": "921020008069979"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "Visnukumar Traders P",
            "interval": "MONTHLY",
            "transactionCount": "6",
            "particulars": "NEFT/27009044677DC/VISNUKUMAR TRADERS P/GGS Enter",
            "account": "921020008069979",
            "startDate": "2022-04-05"
        },
        {
            "amount": "82833",
            "endDate": "2022-09-30",
            "accountType": "SA",
            "transactions": [
                {
                    "id": 4831,
                    "date": "2022-08-31",
                    "amount": 82833.0,
                    "particular": "NEFT CR-ICIC0SF0002-LUMIS LABS INVESTMEN -SHUBHAM YADAV-29159868591DC SHUBHAM YAD AV SALARY AUG ",
                    "counterparty": "Shubham Yad Av, Shubham Yadav",
                    "tags": "NEFT",
                    "balance": 133142.0,
                    "cheque_number": "00029159868591DC ",
                    "type": "CR",
                    "computedBalance": 133142.0,
                    "balanceGap": 0.0,
                    "categories": "Salary",
                    "upiApp": ""
                },
                {
                    "id": 4858,
                    "date": "2022-09-30",
                    "amount": 82833.0,
                    "particular": "NEFT CR-ICIC0SF0002-LUMIS LABS INVESTMEN -SHUBHAM YADAV-29497459001DC SHUBHAM YAD AV SALARY ",
                    "counterparty": "Shubham Yad Av, Shubham Yadav",
                    "tags": "NEFT",
                    "balance": 88358.7,
                    "cheque_number": "00029497459001DC ",
                    "type": "CR",
                    "computedBalance": 88358.7,
                    "balanceGap": 0.0,
                    "categories": "Salary",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "25",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "SA",
                "bankName": "HDFC Bank",
                "accountNumber": "50100477739497"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "Shubham Yad Av, Shubham Yadav",
            "interval": "MONTHLY",
            "transactionCount": "2",
            "particulars": "NEFT CR-ICIC0SF0002-LUMIS LABS INVESTMEN -SHUBHAM YADAV-29159868591DC SHUBHAM YAD AV SALARY AUG",
            "account": "50100477739497",
            "startDate": "2022-08-31"
        },
        {
            "amount": "800",
            "endDate": "2022-07-08",
            "accountType": "SA",
            "transactions": [
                {
                    "id": 4767,
                    "date": "2022-04-12",
                    "amount": 800.0,
                    "particular": "NEFT CR-CITI0000004-WIPRO LTD - WIPRO TE CHNOLOGIES-SHUBHAM YADAV-CITIN2225762749 8 ",
                    "counterparty": "Shubham Yadav, Wipro Ltd",
                    "tags": "NEFT",
                    "balance": 122116.0,
                    "cheque_number": "CITIN22257627498 ",
                    "type": "CR",
                    "computedBalance": 122116.0,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4781,
                    "date": "2022-06-02",
                    "amount": 800.0,
                    "particular": "NEFT CR-CITI0000004-WIPRO LTD - WIPRO TE  CHNOLOGIES-SHUBHAM YADAV-CITIN2228539651 6 ",
                    "counterparty": "Shubham Yadav, Wipro Ltd",
                    "tags": "NEFT",
                    "balance": 50894.0,
                    "cheque_number": "CITIN22285396516 ",
                    "type": "CR",
                    "computedBalance": 50894.0,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4790,
                    "date": "2022-07-08",
                    "amount": 800.0,
                    "particular": "NEFT CR-CITI0000004-WIPRO LTD - WIPRO TE CHNOLOGIES-SHUBHAM YADAV-CITIN2230311807 0 ",
                    "counterparty": "Shubham Yadav, Wipro Ltd",
                    "tags": "NEFT",
                    "balance": 132208.0,
                    "cheque_number": "CITIN22303118070 ",
                    "type": "CR",
                    "computedBalance": 132208.0,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "25",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "SA",
                "bankName": "HDFC Bank",
                "accountNumber": "50100477739497"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Shubham Yadav, Wipro Ltd",
            "interval": "IRREGULAR",
            "transactionCount": "3",
            "particulars": "NEFT CR-CITI0000004-WIPRO LTD - WIPRO TE CHNOLOGIES-SHUBHAM YADAV-CITIN2225762749 8",
            "account": "50100477739497",
            "startDate": "2022-04-12"
        },
        {
            "amount": "293",
            "endDate": "2022-04-16",
            "accountType": "CA",
            "transactions": [
                {
                    "id": 4892,
                    "date": "2022-04-11",
                    "amount": 293.21,
                    "particular": "NEFT-N101221912538833-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 262285.42,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 262285.42,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 4909,
                    "date": "2022-04-16",
                    "amount": 293.21,
                    "particular": "NEFT-N106221919431579-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 227640.03,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 227640.03,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "23",
            "accountDetails": {
                "bankAbbreviation": "BARBIN",
                "accountType": "CA",
                "bankName": "Bank of Baroda",
                "accountNumber": "29780200000863"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Dotpe Pvt Ltdnodal",
            "interval": "IRREGULAR",
            "transactionCount": "2",
            "particulars": "NEFT-N101221912538833-DOTPE PVT LTDNODAL",
            "account": "29780200000863",
            "startDate": "2022-04-11"
        },
        {
            "amount": "1487",
            "endDate": "2022-08-10",
            "accountType": "CA",
            "transactions": [
                {
                    "id": 4952,
                    "date": "2022-05-02",
                    "amount": 1487.34,
                    "particular": "NEFT-N122221939860077-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 693589.88,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 693589.88,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 5129,
                    "date": "2022-06-27",
                    "amount": 1487.13,
                    "particular": "NEFT-N178222013027151-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 554088.92,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 554088.92,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 5278,
                    "date": "2022-08-10",
                    "amount": 1487.34,
                    "particular": "NEFT-N222222073327061-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 54971.07,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 54971.07,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "23",
            "accountDetails": {
                "bankAbbreviation": "BARBIN",
                "accountType": "CA",
                "bankName": "Bank of Baroda",
                "accountNumber": "29780200000863"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Dotpe Pvt Ltdnodal",
            "interval": "IRREGULAR",
            "transactionCount": "3",
            "particulars": "NEFT-N122221939860077-DOTPE PVT LTDNODAL",
            "account": "29780200000863",
            "startDate": "2022-05-02"
        },
        {
            "amount": "1491",
            "endDate": "2022-08-30",
            "accountType": "CA",
            "transactions": [
                {
                    "id": 5151,
                    "date": "2022-07-04",
                    "amount": 1491.78,
                    "particular": "NEFT-N185222022947587-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 316525.69,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 316525.69,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 5335,
                    "date": "2022-08-30",
                    "amount": 1491.78,
                    "particular": "NEFT-N242222096525985-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 359881.95,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 359881.95,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "23",
            "accountDetails": {
                "bankAbbreviation": "BARBIN",
                "accountType": "CA",
                "bankName": "Bank of Baroda",
                "accountNumber": "29780200000863"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Dotpe Pvt Ltdnodal",
            "interval": "IRREGULAR",
            "transactionCount": "2",
            "particulars": "NEFT-N185222022947587-DOTPE PVT LTDNODAL",
            "account": "29780200000863",
            "startDate": "2022-07-04"
        },
        {
            "amount": "1493",
            "endDate": "2022-08-12",
            "accountType": "CA",
            "transactions": [
                {
                    "id": 4895,
                    "date": "2022-04-12",
                    "amount": 1493.03,
                    "particular": "NEFT-N102221914733978-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 288649.7,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 288649.7,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 5103,
                    "date": "2022-06-18",
                    "amount": 1493.03,
                    "particular": "NEFT-N169222004420711-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 280600.18,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 280600.18,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 5108,
                    "date": "2022-06-20",
                    "amount": 1493.03,
                    "particular": "NEFT-N171222005552229-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 564367.04,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 564367.04,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 5143,
                    "date": "2022-07-01",
                    "amount": 1493.03,
                    "particular": "NEFT-N182222019534973-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 666393.66,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 666393.66,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 5179,
                    "date": "2022-07-11",
                    "amount": 1493.03,
                    "particular": "NEFT-N192222033558276-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 280493.45,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 280493.45,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 5181,
                    "date": "2022-07-12",
                    "amount": 1493.03,
                    "particular": "NEFT-N193222035401012-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 308026.64,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 308026.64,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 5192,
                    "date": "2022-07-13",
                    "amount": 1493.03,
                    "particular": "NEFT-N194222036903291-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 85081.91,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 85081.91,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 5289,
                    "date": "2022-08-12",
                    "amount": 1493.03,
                    "particular": "NEFT-N224222076882279-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 339223.83,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 339223.83,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "23",
            "accountDetails": {
                "bankAbbreviation": "BARBIN",
                "accountType": "CA",
                "bankName": "Bank of Baroda",
                "accountNumber": "29780200000863"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Dotpe Pvt Ltdnodal",
            "interval": "IRREGULAR",
            "transactionCount": "8",
            "particulars": "NEFT-N102221914733978-DOTPE PVT LTDNODAL",
            "account": "29780200000863",
            "startDate": "2022-04-12"
        },
        {
            "amount": "1519",
            "endDate": "2022-07-07",
            "accountType": "CA",
            "transactions": [
                {
                    "id": 4985,
                    "date": "2022-05-11",
                    "amount": 1519.28,
                    "particular": "NEFT-N131221954153381-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 468787.62,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 468787.62,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                },
                {
                    "id": 5166,
                    "date": "2022-07-07",
                    "amount": 1519.61,
                    "particular": "NEFT-N188222028419966-DOTPE PVT LTDNODAL ",
                    "counterparty": "Dotpe Pvt Ltdnodal",
                    "tags": "NEFT",
                    "balance": 153983.17,
                    "cheque_number": "",
                    "type": "CR",
                    "computedBalance": 153983.17,
                    "balanceGap": 0.0,
                    "categories": "I/W Funds Transfer / NEFT",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "23",
            "accountDetails": {
                "bankAbbreviation": "BARBIN",
                "accountType": "CA",
                "bankName": "Bank of Baroda",
                "accountNumber": "29780200000863"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Dotpe Pvt Ltdnodal",
            "interval": "IRREGULAR",
            "transactionCount": "2",
            "particulars": "NEFT-N131221954153381-DOTPE PVT LTDNODAL",
            "account": "29780200000863",
            "startDate": "2022-05-11"
        },
        {
            "amount": "25000",
            "endDate": "2022-08-29",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 6200,
                    "date": "2022-07-30",
                    "amount": 25000.0,
                    "particular": "IMPS-221110834850-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0034142433 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8966204.11,
                    "cheque_number": "0000221110834850 ",
                    "type": "CR",
                    "computedBalance": 33795.89,
                    "balanceGap": 8932408.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                },
                {
                    "id": 6421,
                    "date": "2022-08-27",
                    "amount": 25000.0,
                    "particular": "IMPS-223916549528-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0034903064 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8935887.71,
                    "cheque_number": "0000223916549528 ",
                    "type": "CR",
                    "computedBalance": 64112.29,
                    "balanceGap": 8871775.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                },
                {
                    "id": 6429,
                    "date": "2022-08-29",
                    "amount": 25000.0,
                    "particular": "IMPS-224112732214-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0034934983 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8946268.91,
                    "cheque_number": "0000224112732214 ",
                    "type": "CR",
                    "computedBalance": 53731.09,
                    "balanceGap": 8892538.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "Chamakalayil Silks",
            "interval": "MONTHLY",
            "transactionCount": "3",
            "particulars": "IMPS-221110834850-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0034142433",
            "account": "50200015818210",
            "startDate": "2022-07-30"
        },
        {
            "amount": "50000",
            "endDate": "2022-08-16",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5622,
                    "date": "2022-05-18",
                    "amount": 50000.0,
                    "particular": "IMPS-213816704101-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0032216701 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8842213.94,
                    "cheque_number": "0000213816704101 ",
                    "type": "CR",
                    "computedBalance": 157786.06,
                    "balanceGap": 8684428.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                },
                {
                    "id": 5906,
                    "date": "2022-06-20",
                    "amount": 50000.0,
                    "particular": "IMPS-217115795429-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0033083786 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8867483.27,
                    "cheque_number": "0000217115795429 ",
                    "type": "CR",
                    "computedBalance": 132516.73,
                    "balanceGap": 8734967.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                },
                {
                    "id": 6309,
                    "date": "2022-08-16",
                    "amount": 50000.0,
                    "particular": "IMPS-222815571557-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0034598549 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8875752.06,
                    "cheque_number": "0000222815571557 ",
                    "type": "CR",
                    "computedBalance": 124247.94,
                    "balanceGap": 8751504.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "Chamakalayil Silks",
            "interval": "MONTHLY",
            "transactionCount": "3",
            "particulars": "IMPS-213816704101-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0032216701",
            "account": "50200015818210",
            "startDate": "2022-05-18"
        },
        {
            "amount": "55000",
            "endDate": "2022-08-19",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5853,
                    "date": "2022-06-14",
                    "amount": 55000.0,
                    "particular": "IMPS-216515785761-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0032929004 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8796132.01,
                    "cheque_number": "0000216515785761 ",
                    "type": "CR",
                    "computedBalance": 203867.99,
                    "balanceGap": 8592264.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                },
                {
                    "id": 6340,
                    "date": "2022-08-19",
                    "amount": 55000.0,
                    "particular": "IMPS-223112926183-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0034681456 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8764643.46,
                    "cheque_number": "0000223112926183 ",
                    "type": "CR",
                    "computedBalance": 235356.54,
                    "balanceGap": 8529287.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Chamakalayil Silks",
            "interval": "IRREGULAR",
            "transactionCount": "2",
            "particulars": "IMPS-216515785761-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0032929004",
            "account": "50200015818210",
            "startDate": "2022-06-14"
        },
        {
            "amount": "60000",
            "endDate": "2022-08-06",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5887,
                    "date": "2022-06-17",
                    "amount": 60000.0,
                    "particular": "IMPS-216815538476-CHAMAKALAYIL SILKS-SBI  N-XXXXXXXXXXXXX6574-INETIMPSS0033016256 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8906209.51,
                    "cheque_number": "0000216815538476 ",
                    "type": "CR",
                    "computedBalance": 93790.49,
                    "balanceGap": 8812419.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                },
                {
                    "id": 6210,
                    "date": "2022-08-03",
                    "amount": 60000.0,
                    "particular": "IMPS-221514505284-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0034261488 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8965560.4,
                    "cheque_number": "0000221514505284 ",
                    "type": "CR",
                    "computedBalance": 34439.6,
                    "balanceGap": 8931121.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                },
                {
                    "id": 6239,
                    "date": "2022-08-06",
                    "amount": 60000.0,
                    "particular": "IMPS-221812797671-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0034347778 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8889328.2,
                    "cheque_number": "0000221812797671 ",
                    "type": "CR",
                    "computedBalance": 110671.8,
                    "balanceGap": 8778656.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Chamakalayil Silks",
            "interval": "IRREGULAR",
            "transactionCount": "3",
            "particulars": "IMPS-216815538476-CHAMAKALAYIL SILKS-SBI  N-XXXXXXXXXXXXX6574-INETIMPSS0033016256",
            "account": "50200015818210",
            "startDate": "2022-06-17"
        },
        {
            "amount": "80000",
            "endDate": "2022-08-24",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5610,
                    "date": "2022-05-17",
                    "amount": 80000.0,
                    "particular": "IMPS-213712825989-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0032179347 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8910787.19,
                    "cheque_number": "0000213712825989 ",
                    "type": "CR",
                    "computedBalance": 89212.81,
                    "balanceGap": 8821574.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                },
                {
                    "id": 5960,
                    "date": "2022-06-28",
                    "amount": 80000.0,
                    "particular": "IMPS-217915847418-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0033289046 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8892203.31,
                    "cheque_number": "0000217915847418 ",
                    "type": "CR",
                    "computedBalance": 107796.69,
                    "balanceGap": 8784407.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                },
                {
                    "id": 6389,
                    "date": "2022-08-24",
                    "amount": 80000.0,
                    "particular": "IMPS-223615654736-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0034815534 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8845384.07,
                    "cheque_number": "0000223615654736 ",
                    "type": "CR",
                    "computedBalance": 154615.93,
                    "balanceGap": 8690768.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Chamakalayil Silks",
            "interval": "IRREGULAR",
            "transactionCount": "3",
            "particulars": "IMPS-213712825989-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0032179347",
            "account": "50200015818210",
            "startDate": "2022-05-17"
        },
        {
            "amount": "90000",
            "endDate": "2022-08-12",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5661,
                    "date": "2022-05-21",
                    "amount": 90000.0,
                    "particular": "IMPS-214117569966-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0032299249 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8904615.21,
                    "cheque_number": "0000214117569966 ",
                    "type": "CR",
                    "computedBalance": 95384.79,
                    "balanceGap": 8809230.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                },
                {
                    "id": 6288,
                    "date": "2022-08-12",
                    "amount": 90000.0,
                    "particular": "IMPS-222412917898-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0034512343 ",
                    "counterparty": "Chamakalayil Silks",
                    "tags": "IMPS",
                    "balance": -8799602.25,
                    "cheque_number": "0000222412917898 ",
                    "type": "CR",
                    "computedBalance": 200397.75,
                    "balanceGap": 8599204.0,
                    "categories": "I/W Funds Transfer / IMPS",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "Chamakalayil Silks",
            "interval": "QUARTERLY",
            "transactionCount": "2",
            "particulars": "IMPS-214117569966-CHAMAKALAYIL SILKS-SBI N-XXXXXXXXXXXXX6574-INETIMPSS0032299249",
            "account": "50200015818210",
            "startDate": "2022-05-21"
        },
        {
            "amount": "10000",
            "endDate": "2022-08-18",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 6023,
                    "date": "2022-07-07",
                    "amount": 10000.0,
                    "particular": "IMPS-218817875509-SHAN MOHANAN-FDRL-XXXX XXXXXX1101-CHAMAKKALAYILSILKS ",
                    "counterparty": "Chamakkalayilsilks, Shan Mohanan",
                    "tags": "IMPS, Own Fund Transfer",
                    "balance": -8987784.62,
                    "cheque_number": "0000218817875509 ",
                    "type": "CR",
                    "computedBalance": 12215.38,
                    "balanceGap": 8975569.0,
                    "categories": "Transfer To Self",
                    "upiApp": ""
                },
                {
                    "id": 6334,
                    "date": "2022-08-18",
                    "amount": 10000.0,
                    "particular": "IMPS-223017604949-SHAN MOHANAN-FDRL-XXXX XXXXXX1101-CHAMAKKALAYILSILKS ",
                    "counterparty": "Chamakkalayilsilks, Shan Mohanan",
                    "tags": "IMPS, Own Fund Transfer",
                    "balance": -8977339.02,
                    "cheque_number": "0000223017604949 ",
                    "type": "CR",
                    "computedBalance": 22660.98,
                    "balanceGap": 8954678.0,
                    "categories": "Transfer To Self",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Chamakkalayilsilks, Shan Mohanan",
            "interval": "IRREGULAR",
            "transactionCount": "2",
            "particulars": "IMPS-218817875509-SHAN MOHANAN-FDRL-XXXX XXXXXX1101-CHAMAKKALAYILSILKS",
            "account": "50200015818210",
            "startDate": "2022-07-07"
        },
        {
            "amount": "35000",
            "endDate": "2022-08-17",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 6241,
                    "date": "2022-08-06",
                    "amount": 35000.0,
                    "particular": "CASH DEP SELF PALA ",
                    "counterparty": "M/S. CHAMAKKALAYIL SILKS",
                    "tags": "Cash, Own Fund Transfer",
                    "balance": -8867328.2,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 132671.8,
                    "balanceGap": 8734656.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6321,
                    "date": "2022-08-17",
                    "amount": 35000.0,
                    "particular": "CASH DEP SELF PALA ",
                    "counterparty": "M/S. CHAMAKKALAYIL SILKS",
                    "tags": "Cash, Own Fund Transfer",
                    "balance": -8935777.02,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 64222.98,
                    "balanceGap": 8871554.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "M/S. CHAMAKKALAYIL SILKS",
            "interval": "FORTNIGHTLY",
            "transactionCount": "2",
            "particulars": "CASH DEP SELF PALA",
            "account": "50200015818210",
            "startDate": "2022-08-06"
        },
        {
            "amount": "40000",
            "endDate": "2022-08-03",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 6078,
                    "date": "2022-07-16",
                    "amount": 40000.0,
                    "particular": "CASH DEP SELF PALA ",
                    "counterparty": "M/S. CHAMAKKALAYIL SILKS",
                    "tags": "Cash, Own Fund Transfer",
                    "balance": -8928210.36,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 71789.64,
                    "balanceGap": 8856421.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6126,
                    "date": "2022-07-21",
                    "amount": 40000.0,
                    "particular": "CASH DEP SELF PALA ",
                    "counterparty": "M/S. CHAMAKKALAYIL SILKS",
                    "tags": "Cash, Own Fund Transfer",
                    "balance": -8955169.38,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 44830.62,
                    "balanceGap": 8910339.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6202,
                    "date": "2022-07-30",
                    "amount": 40000.0,
                    "particular": "CASH DEP SELF PALA ",
                    "counterparty": "M/S. CHAMAKKALAYIL SILKS",
                    "tags": "Cash, Own Fund Transfer",
                    "balance": -8959204.11,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 40795.89,
                    "balanceGap": 8918408.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6211,
                    "date": "2022-08-03",
                    "amount": 40000.0,
                    "particular": "CASH DEP SELF PALA ",
                    "counterparty": "M/S. CHAMAKKALAYIL SILKS",
                    "tags": "Cash, Own Fund Transfer",
                    "balance": -8925560.4,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 74439.6,
                    "balanceGap": 8851121.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "M/S. CHAMAKKALAYIL SILKS",
            "interval": "IRREGULAR",
            "transactionCount": "4",
            "particulars": "CASH DEP SELF PALA",
            "account": "50200015818210",
            "startDate": "2022-07-16"
        },
        {
            "amount": "50000",
            "endDate": "2022-08-11",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 6073,
                    "date": "2022-07-15",
                    "amount": 50000.0,
                    "particular": "CASH DEP SELF PALA ",
                    "counterparty": "M/S. CHAMAKKALAYIL SILKS",
                    "tags": "Cash, Own Fund Transfer",
                    "balance": -8931455.43,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 68544.57,
                    "balanceGap": 8862911.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6173,
                    "date": "2022-07-27",
                    "amount": 50000.0,
                    "particular": "CASH DEP SELF PALA ",
                    "counterparty": "M/S. CHAMAKKALAYIL SILKS",
                    "tags": "Cash, Own Fund Transfer",
                    "balance": -8912621.5,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 87378.5,
                    "balanceGap": 8825243.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6279,
                    "date": "2022-08-10",
                    "amount": 50000.0,
                    "particular": "CASH DEP SELF PALA ",
                    "counterparty": "M/S. CHAMAKKALAYIL SILKS",
                    "tags": "Cash, Own Fund Transfer",
                    "balance": -8938758.31,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 61241.69,
                    "balanceGap": 8877517.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6283,
                    "date": "2022-08-11",
                    "amount": 50000.0,
                    "particular": "CASH DEP SELF PALA ",
                    "counterparty": "M/S. CHAMAKKALAYIL SILKS",
                    "tags": "Cash, Own Fund Transfer",
                    "balance": -8888305.31,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 111694.69,
                    "balanceGap": 8776611.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "M/S. CHAMAKKALAYIL SILKS",
            "interval": "FORTNIGHTLY",
            "transactionCount": "4",
            "particulars": "CASH DEP SELF PALA",
            "account": "50200015818210",
            "startDate": "2022-07-15"
        },
        {
            "amount": "55000",
            "endDate": "2022-08-23",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 6350,
                    "date": "2022-08-19",
                    "amount": 55000.0,
                    "particular": "CASH DEP SELF PALA ",
                    "counterparty": "M/S. CHAMAKKALAYIL SILKS",
                    "tags": "Cash, Own Fund Transfer",
                    "balance": -8915525.46,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 84474.54,
                    "balanceGap": 8831051.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6384,
                    "date": "2022-08-23",
                    "amount": 55000.0,
                    "particular": "CASH DEP SELF PALA ",
                    "counterparty": "M/S. CHAMAKKALAYIL SILKS",
                    "tags": "Cash, Own Fund Transfer",
                    "balance": -8919727.07,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 80272.93,
                    "balanceGap": 8839454.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "M/S. CHAMAKKALAYIL SILKS",
            "interval": "IRREGULAR",
            "transactionCount": "2",
            "particulars": "CASH DEP SELF PALA",
            "account": "50200015818210",
            "startDate": "2022-08-19"
        },
        {
            "amount": "60000",
            "endDate": "2022-08-12",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 6254,
                    "date": "2022-08-08",
                    "amount": 60000.0,
                    "particular": "CASH DEP SELF PALA ",
                    "counterparty": "M/S. CHAMAKKALAYIL SILKS",
                    "tags": "Cash, Own Fund Transfer",
                    "balance": -8885223.05,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 114776.95,
                    "balanceGap": 8770446.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6293,
                    "date": "2022-08-12",
                    "amount": 60000.0,
                    "particular": "CASH DEP SELF PALA ",
                    "counterparty": "M/S. CHAMAKKALAYIL SILKS",
                    "tags": "Cash, Own Fund Transfer",
                    "balance": -8909602.25,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 90397.75,
                    "balanceGap": 8819204.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "M/S. CHAMAKKALAYIL SILKS",
            "interval": "IRREGULAR",
            "transactionCount": "2",
            "particulars": "CASH DEP SELF PALA",
            "account": "50200015818210",
            "startDate": "2022-08-08"
        },
        {
            "amount": "25000",
            "endDate": "2022-07-29",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5786,
                    "date": "2022-06-01",
                    "amount": 25000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -9007970.25,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": -7970.25,
                    "balanceGap": 9000000.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6064,
                    "date": "2022-07-14",
                    "amount": 25000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8812305.87,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 187694.13,
                    "balanceGap": 8624612.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6191,
                    "date": "2022-07-29",
                    "amount": 25000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8919590.62,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 80409.38,
                    "balanceGap": 8839181.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Pala",
            "interval": "IRREGULAR",
            "transactionCount": "3",
            "particulars": "CASH DEP PALA",
            "account": "50200015818210",
            "startDate": "2022-06-01"
        },
        {
            "amount": "35000",
            "endDate": "2022-06-29",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5821,
                    "date": "2022-06-07",
                    "amount": 35000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8956909.92,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 43090.08,
                    "balanceGap": 8913820.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 5916,
                    "date": "2022-06-21",
                    "amount": 35000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8904392.67,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 95607.33,
                    "balanceGap": 8808785.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 5967,
                    "date": "2022-06-29",
                    "amount": 35000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8963253.37,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 36746.63,
                    "balanceGap": 8926507.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "Pala",
            "interval": "FORTNIGHTLY",
            "transactionCount": "3",
            "particulars": "CASH DEP PALA",
            "account": "50200015818210",
            "startDate": "2022-06-07"
        },
        {
            "amount": "40000",
            "endDate": "2022-07-20",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5836,
                    "date": "2022-06-10",
                    "amount": 40000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8874207.26,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 125792.74,
                    "balanceGap": 8748415.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6000,
                    "date": "2022-07-05",
                    "amount": 40000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8951788.03,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 48211.97,
                    "balanceGap": 8903576.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6010,
                    "date": "2022-07-06",
                    "amount": 40000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8931922.8,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 68077.2,
                    "balanceGap": 8863846.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6114,
                    "date": "2022-07-20",
                    "amount": 40000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8947537.6,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 52462.4,
                    "balanceGap": 8895075.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Pala",
            "interval": "IRREGULAR",
            "transactionCount": "4",
            "particulars": "CASH DEP PALA",
            "account": "50200015818210",
            "startDate": "2022-06-10"
        },
        {
            "amount": "45000",
            "endDate": "2022-08-20",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5826,
                    "date": "2022-06-08",
                    "amount": 45000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8921109.27,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 78890.73,
                    "balanceGap": 8842219.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6359,
                    "date": "2022-08-20",
                    "amount": 45000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8940098.68,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 59901.32,
                    "balanceGap": 8880197.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "Pala",
            "interval": "QUARTERLY",
            "transactionCount": "2",
            "particulars": "CASH DEP PALA",
            "account": "50200015818210",
            "startDate": "2022-06-08"
        },
        {
            "amount": "50000",
            "endDate": "2022-06-04",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5583,
                    "date": "2022-05-12",
                    "amount": 50000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8922840.68,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 77159.32,
                    "balanceGap": 8845681.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 5804,
                    "date": "2022-06-04",
                    "amount": 50000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8810663.16,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 189336.84,
                    "balanceGap": 8621326.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Pala",
            "interval": "IRREGULAR",
            "transactionCount": "2",
            "particulars": "CASH DEP PALA",
            "account": "50200015818210",
            "startDate": "2022-05-12"
        },
        {
            "amount": "55000",
            "endDate": "2022-07-01",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5818,
                    "date": "2022-06-06",
                    "amount": 55000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8942340.92,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 57659.08,
                    "balanceGap": 8884682.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 5898,
                    "date": "2022-06-18",
                    "amount": 55000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8930558.51,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 69441.49,
                    "balanceGap": 8861117.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 5980,
                    "date": "2022-07-01",
                    "amount": 55000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8982483.33,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 17516.67,
                    "balanceGap": 8964967.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "Pala",
            "interval": "FORTNIGHTLY",
            "transactionCount": "3",
            "particulars": "CASH DEP PALA",
            "account": "50200015818210",
            "startDate": "2022-06-06"
        },
        {
            "amount": "60000",
            "endDate": "2022-08-18",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5652,
                    "date": "2022-05-20",
                    "amount": 60000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8925031.75,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 74968.25,
                    "balanceGap": 8850064.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 5708,
                    "date": "2022-05-26",
                    "amount": 60000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8908956.78,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 91043.22,
                    "balanceGap": 8817914.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 5788,
                    "date": "2022-06-02",
                    "amount": 60000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8945489.25,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 54510.75,
                    "balanceGap": 8890978.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 5854,
                    "date": "2022-06-14",
                    "amount": 60000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8736132.01,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 263867.99,
                    "balanceGap": 8472264.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 5872,
                    "date": "2022-06-16",
                    "amount": 60000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8802682.88,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 197317.12,
                    "balanceGap": 8605366.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 5927,
                    "date": "2022-06-23",
                    "amount": 60000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8867042.94,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 132957.06,
                    "balanceGap": 8734086.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6027,
                    "date": "2022-07-08",
                    "amount": 60000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8928036.45,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 71963.55,
                    "balanceGap": 8856073.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6327,
                    "date": "2022-08-18",
                    "amount": 60000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8934281.02,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 65718.98,
                    "balanceGap": 8868562.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Pala",
            "interval": "IRREGULAR",
            "transactionCount": "8",
            "particulars": "CASH DEP PALA",
            "account": "50200015818210",
            "startDate": "2022-05-20"
        },
        {
            "amount": "70000",
            "endDate": "2022-07-13",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5574,
                    "date": "2022-05-11",
                    "amount": 70000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8917100.18,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 82899.82,
                    "balanceGap": 8834200.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 5792,
                    "date": "2022-06-03",
                    "amount": 70000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8872200.41,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 127799.59,
                    "balanceGap": 8744401.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6057,
                    "date": "2022-07-13",
                    "amount": 70000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8713594.92,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 286405.08,
                    "balanceGap": 8427190.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Pala",
            "interval": "IRREGULAR",
            "transactionCount": "3",
            "particulars": "CASH DEP PALA",
            "account": "50200015818210",
            "startDate": "2022-05-11"
        },
        {
            "amount": "80000",
            "endDate": "2022-08-24",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5510,
                    "date": "2022-05-05",
                    "amount": 80000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8797738.78,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 202261.22,
                    "balanceGap": 8595478.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 5611,
                    "date": "2022-05-17",
                    "amount": 80000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8830787.19,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 169212.81,
                    "balanceGap": 8661574.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6390,
                    "date": "2022-08-24",
                    "amount": 80000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8765384.07,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 234615.93,
                    "balanceGap": 8530768.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": "4",
            "missesDates": null,
            "counterparty": "Pala",
            "interval": "FORTNIGHTLY",
            "transactionCount": "3",
            "particulars": "CASH DEP PALA",
            "account": "50200015818210",
            "startDate": "2022-05-05"
        },
        {
            "amount": "110000",
            "endDate": "2022-07-19",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5586,
                    "date": "2022-05-13",
                    "amount": 110000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8813915.68,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 186084.32,
                    "balanceGap": 8627831.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6106,
                    "date": "2022-07-19",
                    "amount": 110000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8833744.14,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 166255.86,
                    "balanceGap": 8667488.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": null,
            "missesDates": null,
            "counterparty": "Pala",
            "interval": "IRREGULAR",
            "transactionCount": "2",
            "particulars": "CASH DEP PALA",
            "account": "50200015818210",
            "startDate": "2022-05-13"
        },
        {
            "amount": "167000",
            "endDate": "2022-08-29",
            "accountType": "OD / CC",
            "transactions": [
                {
                    "id": 5597,
                    "date": "2022-05-16",
                    "amount": 167000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8755139.29,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 244860.71,
                    "balanceGap": 8510279.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                },
                {
                    "id": 6431,
                    "date": "2022-08-29",
                    "amount": 167000.0,
                    "particular": "CASH DEP PALA ",
                    "counterparty": "Pala",
                    "tags": "Cash",
                    "balance": -8784268.91,
                    "cheque_number": "000000000000000 ",
                    "type": "CR",
                    "computedBalance": 215731.09,
                    "balanceGap": 8568538.0,
                    "categories": "Cash & ATM / Cash Deposit",
                    "upiApp": ""
                }
            ],
            "tags": null,
            "transactionType": "CR",
            "accountId": "26",
            "accountDetails": {
                "bankAbbreviation": "HDFCIN",
                "accountType": "OD / CC",
                "bankName": "HDFC Bank",
                "accountNumber": "50200015818210"
            },
            "misses": "0",
            "missesDates": null,
            "counterparty": "Pala",
            "interval": "QUARTERLY",
            "transactionCount": "2",
            "particulars": "CASH DEP PALA",
            "account": "50200015818210",
            "startDate": "2022-05-16"
        }
    ]
}